// CONFIG, AUTOCONFIG, CONFIG_CONSTS


// CONFIG CONSTS
const config_consts = {};
config_consts.ENV_PROD_PORT = '5050';
config_consts.ENV_STG_PORT = '5058';
config_consts.ENV_DEV_PORT = '5059';
config_consts.SEPARATED_LOCALHOST_BACKEND_PORT = '5050'; // when backend running on localhost as separate application


const _detect_env_smart = () => {
  let _env = '?';
  if (window.location.host === "localhost:3000") {
    _env = 'LOCALHOST_DEV';
  } else if (window.location.host === "127.0.0.1:3000") {
    // same as localhost:3000
    _env = 'LOCALHOST_DEV';
  } else {
    // CASE react app build is hosted inside public folder on real backend
    if (window.location.port === config_consts.ENV_PROD_PORT) {
      _env = 'PROD';
    } else if (window.location.port === config_consts.ENV_STG_PORT) {
      _env = 'STG';
    } else if (window.location.port === config_consts.ENV_DEV_PORT) {
      _env = 'DEV';
    } else {
      _env = 'STANDALONE_FRONTEND'; // when frontend build is hosted as separate app
    }
  }
  return _env;
};


// const BACKEND_PORT = 5050;
// const WEBSITE_URL_PREFIX = process.env.PUBLIC_URL;
const WEBSITE_URL_PREFIX = 'http://localhost:3000'; // URL kojim se dolazi do frontenda
// const API_URL_PREFIX = 'http://localhost:3001'; // URL prefix of API urls
// const API_URL_PREFIX = 'http://localhost:5001'; // URL prefix of API urls
// const API_URL_PREFIX = 'http://localhost:3001'; // URL prefix of API urls
const _make_api_url_prefix_smart = () => {
  // make URL prefix for API URLs etc...
  let url_prefix;
  if (window.location.host === "localhost:3000") {
    // (if started local on port 3000 we asume its react without backend)
    // CASE localhost react development server
    // port 3000 is local react development server
    // port 3001 is default express server port
    // url_prefix = 'http://localhost:3001';
    // url_prefix = 'http://localhost:' + BACKEND_PORT;
    url_prefix = 'http://localhost:' + config_consts.SEPARATED_LOCALHOST_BACKEND_PORT;
    // example 'http://localhost:3001'
  } else if (window.location.host === "127.0.0.1:3000") {
    // same as localhost:3000
    // url_prefix = 'http://127.0.0.1:3001';
    // url_prefix = 'http://127.0.0.1:' + BACKEND_PORT;
    url_prefix = 'http://127.0.0.1:' + config_consts.SEPARATED_LOCALHOST_BACKEND_PORT;
  } else {
    // CASE react app build is hosted inside public folder on real backend
    // no port changes because port is the same for frontend and backend
    url_prefix = window.location.protocol + '//' + window.location.host;
    // example 'http://mywebsite.com'
    // example 'http://localhost:4444'
    // example 'http://mywebsite.com:4444'
  }
  return url_prefix;
};


const config = {};
config.detected_env = _detect_env_smart();
config.webisteUrlPrefix = WEBSITE_URL_PREFIX;
// config.apiUrlPrefix = API_URL_PREFIX;
config.apiUrlPrefix = _make_api_url_prefix_smart();
config.webisteBrowserTitle = '* TERMOVENT SASTAVLJAČ DEMO';
config.webisteBrowserTitle_prod = 'TERMOVENT SASTAVLJAČ';
config.webisteBrowserTitle_stg = '*STG* TERMOVENT SASTAVLJAČ';
config.webisteBrowserTitle_dev = '*DEV* TERMOVENT SASTAVLJAČ';
config.optimizedBuild = false; // ukljuciti za finalnu verziju - pravi build bez debuggera
config.devMode = true; // mode u kojem zelimo da se prikazuju opcije koje klijentu nisu bitne

config.backend_ganus_enabled = false; // enable/disable genus functionality

config.localhost_backend_port = config_consts.SEPARATED_LOCALHOST_BACKEND_PORT; // when backend running on localhost as separate application
config.TOKEN_LOCAL_KEY = 'sastavljac_client_token'; // name of the token key in local storage
config.TOKEN_COOKIE_KEY = 'sastavljac-token'; // name of the cookie for token
// config.TOKEN_HEADER_KEY = 'X-ter1-token'; // name of the token key in http request headers
config.TOKEN_HEADER_KEY = 'x-sastavljac-token'; // name of the token key in http request headers
config.useCookieToken = false; // koristimo cookie za slanje tokena uz http request
config.useHeaderToken = true; // koristimo headers za slanje tokena uz http request
config.test_token_value = '123456789';
config.initial_token_value = 'none_token_placeholder';


config.simulateBackend = true; // true simulirani backend / false pravi backend
config.ajaxSimulatorDelay = 500; // vreme (miliseconds) dok ajax simulator ne posalje response
config.FDB_KEY = 'sastavljac_app_fdb'; // key for local storage simulated backend on frontend database
config.fdb_store_into_filesystem = true; // store into local storage
config.versions = {};
config.versions.simDatabaseVersionNeeded = 'structure2023-01-27a1'; // key for database structure


// Podešavanja pred pokretanje
// NAPOMENA: OVO MORA BITI IZVRŠENO U APLIKACIJI PRE NEGO ŠTO BILO KOJI DEO APLIKACIJE POČNE DA UVAŽAVA config PARAMETRE
config.company_env_backend_sim = true;
export const _config_change_app_env_backend_sim = (enabled) => {
  config.company_env_backend_sim = enabled;
  config.simulateBackend = enabled;
};
config.company_env_mes_test_is_enabled = true;
export const _config_change_company_env_mes_test_is_enabled = (enabled) => {
  // NE KORISTI SE SADA
  // ovo smo koristili samo dok je postojao jedan company MES environment za testiranje
  config.company_env_mes_test_is_enabled = enabled;
};
config.company_env_mes = 'TEST'; // NOVO 2023-07-12
export const _config_change_company_env_mes = (what) => {
  config.company_env_mes = what;
};


// CHEATS
config.dev_autorun_cheats = false; // automaticaly start cheats


export default config;